
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { bool_type, record_type, class_type, option_type, string_type, list_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { exists, contains, isEmpty, empty, singleton, filter, tryFind, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { stringHash, safeHash, equals } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { RoleId_$reflection, StorageId_$reflection } from "./Shared.js";
import { ReceiverTypeNameModule_all, ReceiverTypeName_$reflection } from "./User.js";
import { toArray, orElse, map, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { tryFind as tryFind_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { exists as exists_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";

export class PermissionScope extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoAccess", "Own", "SelectedStorages", "AssignedStorages", "All"];
    }
}

export function PermissionScope_$reflection() {
    return union_type("Shared.Roles.PermissionScope", [], PermissionScope, () => [[], [], [], [], []]);
}

export function PermissionScope__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "own";
        case 2:
            return "selected";
        case 3:
            return "assigned";
        case 4:
            return "all";
        default:
            return "none";
    }
}

export function PermissionScope__ToI18nString(this$) {
    return concat("permission_scope.", PermissionScope__get_Key(this$), ...".label");
}

export function PermissionScope__ToI18nDescriptionString(this$) {
    return concat("permission_scope.", PermissionScope__get_Key(this$), ...".description");
}

export function PermissionScope__ToI18nExampleString(this$) {
    return concat("permission_scope.", PermissionScope__get_Key(this$), ...".example");
}

export const PermissionScopeModule_all = ofArray([new PermissionScope(0, []), new PermissionScope(1, []), new PermissionScope(2, []), new PermissionScope(3, []), new PermissionScope(4, [])]);

export function PermissionScopeModule_tryParse(key) {
    return tryFind((scope) => (PermissionScope__get_Key(scope) === key), PermissionScopeModule_all);
}

export class BookingScope extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoBooking", "StorageRules", "AllStorages"];
    }
}

export function BookingScope_$reflection() {
    return union_type("Shared.Roles.BookingScope", [], BookingScope, () => [[], [], []]);
}

export function BookingScope__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "storage_rules";
        case 2:
            return "all";
        default:
            return "none";
    }
}

export function BookingScope__ToI18nString(this$) {
    return concat("booking_scope.", BookingScope__get_Key(this$), ...".label");
}

export function BookingScope__ToI18nDescriptionString(this$) {
    return concat("booking_scope.", BookingScope__get_Key(this$), ...".description");
}

export function BookingScope__ToI18nExampleString(this$) {
    return concat("booking_scope.", BookingScope__get_Key(this$), ...".example");
}

export const BookingScopeModule_all = ofArray([new BookingScope(0, []), new BookingScope(1, []), new BookingScope(2, [])]);

export function BookingScopeModule_tryParse(key) {
    return tryFind((scope) => (BookingScope__get_Key(scope) === key), BookingScopeModule_all);
}

export class ReceiverScope extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoAccess", "SelectedTypes", "All"];
    }
}

export function ReceiverScope_$reflection() {
    return union_type("Shared.Roles.ReceiverScope", [], ReceiverScope, () => [[], [], []]);
}

export function ReceiverScope__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "selected_types";
        case 2:
            return "all";
        default:
            return "none";
    }
}

export function ReceiverScope__ToI18nString(this$) {
    return concat("receiver_scope.", ReceiverScope__get_Key(this$), ...".label");
}

export function ReceiverScope__ToI18nDescriptionString(this$) {
    return concat("receiver_scope.", ReceiverScope__get_Key(this$), ...".description");
}

export function ReceiverScope__ToI18nExampleString(this$) {
    return concat("receiver_scope.", ReceiverScope__get_Key(this$), ...".example");
}

export const ReceiverScopeModule_all = ofArray([new ReceiverScope(0, []), new ReceiverScope(1, []), new ReceiverScope(2, [])]);

export function ReceiverScopeModule_tryParse(key) {
    return tryFind((scope) => (ReceiverScope__get_Key(scope) === key), ReceiverScopeModule_all);
}

export class PermissionLadder extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Standard", "Booking", "Binary", "WithReceiverTypes"];
    }
}

export function PermissionLadder_$reflection() {
    return union_type("Shared.Roles.PermissionLadder", [], PermissionLadder, () => [[["Item", list_type(PermissionScope_$reflection())]], [], [], []]);
}

export function PermissionLadder_get_OwnAssignedAll() {
    return new PermissionLadder(0, [ofArray([new PermissionScope(1, []), new PermissionScope(2, []), new PermissionScope(3, []), new PermissionScope(4, [])])]);
}

export function PermissionLadder_get_AssignedAll() {
    return new PermissionLadder(0, [ofArray([new PermissionScope(2, []), new PermissionScope(3, []), new PermissionScope(4, [])])]);
}

export function PermissionLadder_get_OwnAll() {
    return new PermissionLadder(0, [ofArray([new PermissionScope(1, []), new PermissionScope(4, [])])]);
}

export class PermissionGroup extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Inventory", "Receiver", "User", "Roles", "ApiKeys", "Storage", "Location", "Category", "CustomFields", "Stocktaking", "Inspection", "Procedure", "Dispolist", "Customer", "BusinessUnit", "Notifications", "Reports", "Calendar", "DataExchange", "Administration", "Telematics"];
    }
}

export function PermissionGroup_$reflection() {
    return union_type("Shared.Roles.PermissionGroup", [], PermissionGroup, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function PermissionGroup__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "receiver";
        case 2:
            return "user";
        case 3:
            return "roles";
        case 4:
            return "api_keys";
        case 5:
            return "storage";
        case 6:
            return "location";
        case 7:
            return "category";
        case 8:
            return "custom_fields";
        case 9:
            return "stocktaking";
        case 10:
            return "inspection";
        case 11:
            return "procedure";
        case 12:
            return "dispolist";
        case 13:
            return "customer";
        case 14:
            return "business_unit";
        case 15:
            return "notifications";
        case 16:
            return "reports";
        case 17:
            return "calendar";
        case 18:
            return "data_exchange";
        case 19:
            return "administration";
        case 20:
            return "telematics";
        default:
            return "inventory";
    }
}

export function PermissionGroup__ToI18nString(this$) {
    return concat("permission_group.", ...PermissionGroup__get_Key(this$));
}

export function PermissionGroup__ToI18nDescriptionString(this$) {
    return concat("permission_group_description.", ...PermissionGroup__get_Key(this$));
}

export const PermissionGroupModule_ordered = ofArray([new PermissionGroup(0, []), new PermissionGroup(15, []), new PermissionGroup(1, []), new PermissionGroup(9, []), new PermissionGroup(10, []), new PermissionGroup(11, []), new PermissionGroup(12, []), new PermissionGroup(16, []), new PermissionGroup(17, []), new PermissionGroup(5, []), new PermissionGroup(6, []), new PermissionGroup(7, []), new PermissionGroup(8, []), new PermissionGroup(2, []), new PermissionGroup(3, []), new PermissionGroup(14, []), new PermissionGroup(13, []), new PermissionGroup(4, []), new PermissionGroup(18, []), new PermissionGroup(19, []), new PermissionGroup(20, [])]);

export class OwnScopeMeaning extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AssignedInventory", "OwnEntriesOrAssignedInventory", "AssignedStorages", "StocktakingParticipant", "StocktakingHelper", "ProcedureParticipant", "OwnBookings"];
    }
}

export function OwnScopeMeaning_$reflection() {
    return union_type("Shared.Roles.OwnScopeMeaning", [], OwnScopeMeaning, () => [[], [], [], [], [], [], []]);
}

export function OwnScopeMeaning__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "own_entries_or_assigned_inventory";
        case 2:
            return "assigned_storages";
        case 3:
            return "stocktaking_participant";
        case 4:
            return "stocktaking_helper";
        case 5:
            return "procedure_participant";
        case 6:
            return "own_bookings";
        default:
            return "assigned_inventory";
    }
}

export function OwnScopeMeaning__ToI18nString(this$) {
    return concat("permission_scope.own.meaning.", ...OwnScopeMeaning__get_Key(this$));
}

export class PermissionRow extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Reservations", "Reminders", "QrCodes", "InventoryDocuments", "InternalDocuments", "CommercialData", "History", "Notices", "ReportProblem", "ProblemReports", "ReceiverDocuments", "InspectionTemplates", "ProcedureTemplates", "ProcedureLogs"];
    }
}

export function PermissionRow_$reflection() {
    return union_type("Shared.Roles.PermissionRow", [], PermissionRow, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function PermissionRow__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "reminder";
        case 2:
            return "qr_code";
        case 3:
            return "document";
        case 4:
            return "internal_document";
        case 5:
            return "commercial_data";
        case 6:
            return "history";
        case 7:
            return "notice";
        case 8:
            return "report_problem";
        case 9:
            return "problem_report";
        case 10:
            return "document";
        case 11:
            return "template";
        case 12:
            return "template";
        case 13:
            return "log";
        default:
            return "reservation";
    }
}

function PermissionRow__get_I18nKey(this$) {
    switch (this$.tag) {
        case 3:
            return "inventory_document";
        case 10:
            return "receiver_document";
        case 11:
            return "inspection_template";
        case 12:
            return "procedure_template";
        case 13:
            return "procedure_log";
        default:
            return PermissionRow__get_Key(this$);
    }
}

export function PermissionRow__ToI18nString(this$) {
    return concat("permission_row.", PermissionRow__get_I18nKey(this$), ...".label");
}

export function PermissionRow__ToI18nDescriptionString(this$) {
    return concat("permission_row.", PermissionRow__get_I18nKey(this$), ...".description");
}

function inGroup(group, action, ladder) {
    return [group, undefined, action, ladder];
}

function inRow(group, row, action, ladder) {
    return [group, row, action, ladder];
}

export class Permission extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InventoryRead", "InventoryCreate", "InventoryUpdate", "InventoryDelete", "InventoryChangeState", "InventoryChangeStorage", "InventoryAssign", "InventoryReturn", "InventoryRequestReturn", "InventoryChangeBusinessUnit", "InventoryReservationRead", "InventoryReservationCreate", "InventoryReservationUpdate", "InventoryReservationDelete", "InventoryReserveForeignReceivers", "InventoryReserveForSelf", "InventoryGlobalAppSearch", "InventoryUserToUserAssignmentViaSelection", "InventoryReminderRead", "InventoryReminderCreate", "InventoryReminderUpdate", "InventoryReminderDelete", "InventoryQrCodeCreate", "InventoryQrCodeDelete", "InventoryLabelPrint", "InventoryDocumentRead", "InventoryDocumentCreate", "InventoryDocumentUpdate", "InventoryDocumentDelete", "InventoryInternalDocumentRead", "InventoryCommercialDataRead", "InventoryCommercialDataUpdate", "InventoryHistoryRead", "InventoryNoticeRead", "InventoryNoticeCreate", "InventoryNoticeUpdate", "InventoryNoticeDelete", "InventoryReportProblemCreate", "InventoryProblemReportRead", "InventoryProblemReportUpdate", "InventoryProblemReportDelete", "ReceiverRead", "ReceiverCreate", "ReceiverUpdate", "ReceiverDelete", "ReceiverArchive", "ReceiverManageQrCodes", "ReceiverDocumentRead", "ReceiverDocumentCreate", "ReceiverDocumentUpdate", "ReceiverDocumentDelete", "ReceiverInternalDocumentRead", "UserRead", "UserCreate", "UserUpdate", "UserDelete", "UserManageCredentials", "UserManageVisibleReceivers", "RolesRead", "RolesCreate", "RolesUpdate", "RolesDelete", "ApiKeysRead", "ApiKeysCreate", "ApiKeysDelete", "StorageRead", "StorageCreate", "StorageUpdate", "StorageDelete", "LocationRead", "LocationCreate", "LocationUpdate", "LocationDelete", "CategoryRead", "CategoryCreate", "CategoryUpdate", "CategoryDelete", "CategoryManageMinimumQuantities", "CustomFieldsRead", "CustomFieldsCreate", "CustomFieldsUpdate", "CustomFieldsDelete", "StocktakingRead", "StocktakingCreate", "StocktakingUpdate", "StocktakingDelete", "StocktakingRecordResults", "StocktakingCorrect", "InspectionRead", "InspectionCreate", "InspectionUpdate", "InspectionDelete", "InspectionRecordResults", "ProcedureReadTemplates", "ProcedureCreateTemplate", "ProcedureUpdateTemplate", "ProcedureDeleteTemplate", "ProcedureRead", "DispolistRead", "DispolistCreate", "DispolistUpdate", "DispolistDelete", "CustomerReadSettings", "CustomerManageSettings", "CustomerManageBilling", "AdministrationReceiveNotificationEmails", "BusinessUnitRead", "BusinessUnitCreate", "BusinessUnitUpdate", "BusinessUnitDelete", "NotificationsRead", "NotificationsManage", "ReportsRead", "CalendarRead", "InventoryImport", "InventoryExport", "InventoryBulkUpdate", "ReceiverImport", "InspectionImport", "TelematicsRead", "TelematicsAssign", "TelematicsManageConnection"];
    }
}

export function Permission_$reflection() {
    return union_type("Shared.Roles.Permission", [], Permission, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

function Permission__get_Definition(this$) {
    switch (this$.tag) {
        case 1:
            return inGroup(new PermissionGroup(0, []), "create", PermissionLadder_get_AssignedAll());
        case 2:
            return inGroup(new PermissionGroup(0, []), "update", PermissionLadder_get_AssignedAll());
        case 3:
            return inGroup(new PermissionGroup(0, []), "delete", PermissionLadder_get_AssignedAll());
        case 4:
            return inGroup(new PermissionGroup(0, []), "change_state", PermissionLadder_get_AssignedAll());
        case 5:
            return inGroup(new PermissionGroup(0, []), "change_storage", PermissionLadder_get_AssignedAll());
        case 6:
            return inGroup(new PermissionGroup(0, []), "assign", new PermissionLadder(1, []));
        case 7:
            return inGroup(new PermissionGroup(0, []), "return", new PermissionLadder(1, []));
        case 8:
            return inGroup(new PermissionGroup(0, []), "request_return", PermissionLadder_get_AssignedAll());
        case 9:
            return inGroup(new PermissionGroup(0, []), "change_business_unit", new PermissionLadder(2, []));
        case 10:
            return inRow(new PermissionGroup(0, []), new PermissionRow(0, []), "read", PermissionLadder_get_OwnAssignedAll());
        case 11:
            return inRow(new PermissionGroup(0, []), new PermissionRow(0, []), "create", PermissionLadder_get_AssignedAll());
        case 12:
            return inRow(new PermissionGroup(0, []), new PermissionRow(0, []), "update", PermissionLadder_get_OwnAssignedAll());
        case 13:
            return inRow(new PermissionGroup(0, []), new PermissionRow(0, []), "delete", PermissionLadder_get_OwnAssignedAll());
        case 14:
            return inGroup(new PermissionGroup(0, []), "reserve_foreign_receivers", new PermissionLadder(3, []));
        case 15:
            return inGroup(new PermissionGroup(0, []), "reserve_for_self", new PermissionLadder(2, []));
        case 16:
            return inGroup(new PermissionGroup(0, []), "global_app_search", new PermissionLadder(2, []));
        case 17:
            return inGroup(new PermissionGroup(0, []), "user_to_user_assignment_via_selection", new PermissionLadder(2, []));
        case 18:
            return inRow(new PermissionGroup(0, []), new PermissionRow(1, []), "read", PermissionLadder_get_OwnAssignedAll());
        case 19:
            return inRow(new PermissionGroup(0, []), new PermissionRow(1, []), "create", PermissionLadder_get_AssignedAll());
        case 20:
            return inRow(new PermissionGroup(0, []), new PermissionRow(1, []), "update", PermissionLadder_get_AssignedAll());
        case 21:
            return inRow(new PermissionGroup(0, []), new PermissionRow(1, []), "delete", PermissionLadder_get_AssignedAll());
        case 22:
            return inRow(new PermissionGroup(0, []), new PermissionRow(2, []), "create", PermissionLadder_get_AssignedAll());
        case 23:
            return inRow(new PermissionGroup(0, []), new PermissionRow(2, []), "delete", PermissionLadder_get_AssignedAll());
        case 24:
            return inGroup(new PermissionGroup(0, []), "print_labels", PermissionLadder_get_AssignedAll());
        case 25:
            return inRow(new PermissionGroup(0, []), new PermissionRow(3, []), "read", PermissionLadder_get_OwnAssignedAll());
        case 26:
            return inRow(new PermissionGroup(0, []), new PermissionRow(3, []), "create", PermissionLadder_get_AssignedAll());
        case 27:
            return inRow(new PermissionGroup(0, []), new PermissionRow(3, []), "update", PermissionLadder_get_AssignedAll());
        case 28:
            return inRow(new PermissionGroup(0, []), new PermissionRow(3, []), "delete", PermissionLadder_get_AssignedAll());
        case 29:
            return inRow(new PermissionGroup(0, []), new PermissionRow(4, []), "read", new PermissionLadder(2, []));
        case 30:
            return inRow(new PermissionGroup(0, []), new PermissionRow(5, []), "read", PermissionLadder_get_AssignedAll());
        case 31:
            return inRow(new PermissionGroup(0, []), new PermissionRow(5, []), "update", PermissionLadder_get_AssignedAll());
        case 32:
            return inRow(new PermissionGroup(0, []), new PermissionRow(6, []), "read", PermissionLadder_get_AssignedAll());
        case 33:
            return inRow(new PermissionGroup(0, []), new PermissionRow(7, []), "read", PermissionLadder_get_OwnAssignedAll());
        case 34:
            return inRow(new PermissionGroup(0, []), new PermissionRow(7, []), "create", PermissionLadder_get_OwnAssignedAll());
        case 35:
            return inRow(new PermissionGroup(0, []), new PermissionRow(7, []), "update", PermissionLadder_get_OwnAssignedAll());
        case 36:
            return inRow(new PermissionGroup(0, []), new PermissionRow(7, []), "delete", PermissionLadder_get_OwnAssignedAll());
        case 37:
            return inRow(new PermissionGroup(0, []), new PermissionRow(8, []), "create", new PermissionLadder(2, []));
        case 38:
            return inRow(new PermissionGroup(0, []), new PermissionRow(9, []), "read", PermissionLadder_get_OwnAssignedAll());
        case 39:
            return inRow(new PermissionGroup(0, []), new PermissionRow(9, []), "update", PermissionLadder_get_AssignedAll());
        case 40:
            return inRow(new PermissionGroup(0, []), new PermissionRow(9, []), "delete", PermissionLadder_get_AssignedAll());
        case 41:
            return inGroup(new PermissionGroup(1, []), "read", new PermissionLadder(3, []));
        case 42:
            return inGroup(new PermissionGroup(1, []), "create", new PermissionLadder(3, []));
        case 43:
            return inGroup(new PermissionGroup(1, []), "update", new PermissionLadder(3, []));
        case 44:
            return inGroup(new PermissionGroup(1, []), "delete", new PermissionLadder(3, []));
        case 45:
            return inGroup(new PermissionGroup(1, []), "archive", new PermissionLadder(3, []));
        case 46:
            return inGroup(new PermissionGroup(1, []), "manage_qr_codes", new PermissionLadder(3, []));
        case 47:
            return inRow(new PermissionGroup(1, []), new PermissionRow(10, []), "read", new PermissionLadder(3, []));
        case 48:
            return inRow(new PermissionGroup(1, []), new PermissionRow(10, []), "create", new PermissionLadder(3, []));
        case 49:
            return inRow(new PermissionGroup(1, []), new PermissionRow(10, []), "update", new PermissionLadder(3, []));
        case 50:
            return inRow(new PermissionGroup(1, []), new PermissionRow(10, []), "delete", new PermissionLadder(3, []));
        case 51:
            return inRow(new PermissionGroup(1, []), new PermissionRow(4, []), "read", new PermissionLadder(2, []));
        case 52:
            return inGroup(new PermissionGroup(2, []), "read", new PermissionLadder(2, []));
        case 53:
            return inGroup(new PermissionGroup(2, []), "create", new PermissionLadder(2, []));
        case 54:
            return inGroup(new PermissionGroup(2, []), "update", new PermissionLadder(2, []));
        case 55:
            return inGroup(new PermissionGroup(2, []), "delete", new PermissionLadder(2, []));
        case 56:
            return inGroup(new PermissionGroup(2, []), "manage_credentials", new PermissionLadder(2, []));
        case 57:
            return inGroup(new PermissionGroup(2, []), "manage_visible_receivers", new PermissionLadder(2, []));
        case 58:
            return inGroup(new PermissionGroup(3, []), "read", new PermissionLadder(2, []));
        case 59:
            return inGroup(new PermissionGroup(3, []), "create", new PermissionLadder(2, []));
        case 60:
            return inGroup(new PermissionGroup(3, []), "update", new PermissionLadder(2, []));
        case 61:
            return inGroup(new PermissionGroup(3, []), "delete", new PermissionLadder(2, []));
        case 62:
            return inGroup(new PermissionGroup(4, []), "read", new PermissionLadder(2, []));
        case 63:
            return inGroup(new PermissionGroup(4, []), "create", new PermissionLadder(2, []));
        case 64:
            return inGroup(new PermissionGroup(4, []), "delete", new PermissionLadder(2, []));
        case 65:
            return inGroup(new PermissionGroup(5, []), "read", PermissionLadder_get_OwnAssignedAll());
        case 66:
            return inGroup(new PermissionGroup(5, []), "create", new PermissionLadder(2, []));
        case 67:
            return inGroup(new PermissionGroup(5, []), "update", new PermissionLadder(2, []));
        case 68:
            return inGroup(new PermissionGroup(5, []), "delete", new PermissionLadder(2, []));
        case 69:
            return inGroup(new PermissionGroup(6, []), "read", new PermissionLadder(2, []));
        case 70:
            return inGroup(new PermissionGroup(6, []), "create", new PermissionLadder(2, []));
        case 71:
            return inGroup(new PermissionGroup(6, []), "update", new PermissionLadder(2, []));
        case 72:
            return inGroup(new PermissionGroup(6, []), "delete", new PermissionLadder(2, []));
        case 73:
            return inGroup(new PermissionGroup(7, []), "read", new PermissionLadder(2, []));
        case 74:
            return inGroup(new PermissionGroup(7, []), "create", new PermissionLadder(2, []));
        case 75:
            return inGroup(new PermissionGroup(7, []), "update", new PermissionLadder(2, []));
        case 76:
            return inGroup(new PermissionGroup(7, []), "delete", new PermissionLadder(2, []));
        case 77:
            return inGroup(new PermissionGroup(7, []), "manage_minimum_quantities", PermissionLadder_get_AssignedAll());
        case 78:
            return inGroup(new PermissionGroup(8, []), "read", new PermissionLadder(2, []));
        case 79:
            return inGroup(new PermissionGroup(8, []), "create", new PermissionLadder(2, []));
        case 80:
            return inGroup(new PermissionGroup(8, []), "update", new PermissionLadder(2, []));
        case 81:
            return inGroup(new PermissionGroup(8, []), "delete", new PermissionLadder(2, []));
        case 82:
            return inGroup(new PermissionGroup(9, []), "read", PermissionLadder_get_OwnAll());
        case 83:
            return inGroup(new PermissionGroup(9, []), "create", new PermissionLadder(2, []));
        case 84:
            return inGroup(new PermissionGroup(9, []), "update", new PermissionLadder(2, []));
        case 85:
            return inGroup(new PermissionGroup(9, []), "delete", new PermissionLadder(2, []));
        case 86:
            return inGroup(new PermissionGroup(9, []), "record_results", PermissionLadder_get_OwnAll());
        case 87:
            return inGroup(new PermissionGroup(9, []), "correct", new PermissionLadder(2, []));
        case 88:
            return inRow(new PermissionGroup(10, []), new PermissionRow(11, []), "read", new PermissionLadder(2, []));
        case 89:
            return inRow(new PermissionGroup(10, []), new PermissionRow(11, []), "create", new PermissionLadder(2, []));
        case 90:
            return inRow(new PermissionGroup(10, []), new PermissionRow(11, []), "update", new PermissionLadder(2, []));
        case 91:
            return inRow(new PermissionGroup(10, []), new PermissionRow(11, []), "delete", new PermissionLadder(2, []));
        case 92:
            return inGroup(new PermissionGroup(10, []), "record_results", PermissionLadder_get_AssignedAll());
        case 93:
            return inRow(new PermissionGroup(11, []), new PermissionRow(12, []), "read", new PermissionLadder(2, []));
        case 94:
            return inRow(new PermissionGroup(11, []), new PermissionRow(12, []), "create", new PermissionLadder(2, []));
        case 95:
            return inRow(new PermissionGroup(11, []), new PermissionRow(12, []), "update", new PermissionLadder(2, []));
        case 96:
            return inRow(new PermissionGroup(11, []), new PermissionRow(12, []), "delete", new PermissionLadder(2, []));
        case 97:
            return inRow(new PermissionGroup(11, []), new PermissionRow(13, []), "read", PermissionLadder_get_OwnAssignedAll());
        case 98:
            return inGroup(new PermissionGroup(12, []), "read", new PermissionLadder(2, []));
        case 99:
            return inGroup(new PermissionGroup(12, []), "create", new PermissionLadder(2, []));
        case 100:
            return inGroup(new PermissionGroup(12, []), "update", new PermissionLadder(2, []));
        case 101:
            return inGroup(new PermissionGroup(12, []), "delete", new PermissionLadder(2, []));
        case 102:
            return inGroup(new PermissionGroup(13, []), "read_settings", new PermissionLadder(2, []));
        case 103:
            return inGroup(new PermissionGroup(13, []), "manage_settings", new PermissionLadder(2, []));
        case 104:
            return inGroup(new PermissionGroup(13, []), "manage_billing", new PermissionLadder(2, []));
        case 105:
            return inGroup(new PermissionGroup(19, []), "receive_notification_emails", new PermissionLadder(2, []));
        case 106:
            return inGroup(new PermissionGroup(14, []), "read", new PermissionLadder(2, []));
        case 107:
            return inGroup(new PermissionGroup(14, []), "create", new PermissionLadder(2, []));
        case 108:
            return inGroup(new PermissionGroup(14, []), "update", new PermissionLadder(2, []));
        case 109:
            return inGroup(new PermissionGroup(14, []), "delete", new PermissionLadder(2, []));
        case 110:
            return inGroup(new PermissionGroup(15, []), "read", PermissionLadder_get_OwnAssignedAll());
        case 111:
            return inGroup(new PermissionGroup(15, []), "manage", PermissionLadder_get_AssignedAll());
        case 112:
            return inGroup(new PermissionGroup(16, []), "read", new PermissionLadder(2, []));
        case 113:
            return inGroup(new PermissionGroup(17, []), "read", PermissionLadder_get_OwnAssignedAll());
        case 114:
            return inGroup(new PermissionGroup(18, []), "inventory_import", new PermissionLadder(2, []));
        case 115:
            return inGroup(new PermissionGroup(18, []), "inventory_export", new PermissionLadder(2, []));
        case 116:
            return inGroup(new PermissionGroup(18, []), "bulk_update", new PermissionLadder(2, []));
        case 117:
            return inGroup(new PermissionGroup(18, []), "receiver_import", new PermissionLadder(2, []));
        case 118:
            return inGroup(new PermissionGroup(18, []), "inspection_import", new PermissionLadder(2, []));
        case 119:
            return inGroup(new PermissionGroup(20, []), "read", PermissionLadder_get_OwnAll());
        case 120:
            return inGroup(new PermissionGroup(20, []), "assign", new PermissionLadder(2, []));
        case 121:
            return inGroup(new PermissionGroup(20, []), "manage_connection", new PermissionLadder(2, []));
        default:
            return inGroup(new PermissionGroup(0, []), "read", PermissionLadder_get_OwnAssignedAll());
    }
}

export function Permission__get_Group(this$) {
    return Permission__get_Definition(this$)[0];
}

export function Permission__get_Row(this$) {
    return Permission__get_Definition(this$)[1];
}

export function Permission__get_Key(this$) {
    const matchValue = Permission__get_Definition(this$);
    if (matchValue[1] != null) {
        const row = matchValue[1];
        return `${PermissionGroup__get_Key(matchValue[0])}.${PermissionRow__get_Key(row)}.${matchValue[2]}`;
    }
    else {
        return concat(PermissionGroup__get_Key(matchValue[0]), ".", ...matchValue[2]);
    }
}

export function Permission__get_Ladder(this$) {
    return Permission__get_Definition(this$)[3];
}

export function Permission__ToI18nString(this$) {
    return concat("permission.", Permission__get_Key(this$), ...".label");
}

export function Permission__ToI18nDescriptionString(this$) {
    return concat("permission.", Permission__get_Key(this$), ...".description");
}

export class PermissionColumn extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Read", "Create", "Update", "Delete", "Manage", "Additional"];
    }
}

export function PermissionColumn_$reflection() {
    return union_type("Shared.Roles.PermissionColumn", [], PermissionColumn, () => [[], [], [], [], [], []]);
}

export function PermissionColumn__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "create";
        case 2:
            return "update";
        case 3:
            return "delete";
        case 4:
            return "manage";
        case 5:
            return "additional";
        default:
            return "read";
    }
}

export function PermissionColumn__ToI18nString(this$) {
    return concat("permission_column.", ...PermissionColumn__get_Key(this$));
}

export const PermissionColumnModule_crud = ofArray([new PermissionColumn(0, []), new PermissionColumn(1, []), new PermissionColumn(2, []), new PermissionColumn(3, [])]);

export const PermissionModule_all = ofArray([new Permission(0, []), new Permission(1, []), new Permission(2, []), new Permission(3, []), new Permission(4, []), new Permission(5, []), new Permission(6, []), new Permission(7, []), new Permission(8, []), new Permission(9, []), new Permission(10, []), new Permission(11, []), new Permission(12, []), new Permission(13, []), new Permission(14, []), new Permission(15, []), new Permission(16, []), new Permission(17, []), new Permission(18, []), new Permission(19, []), new Permission(20, []), new Permission(21, []), new Permission(22, []), new Permission(23, []), new Permission(24, []), new Permission(25, []), new Permission(26, []), new Permission(27, []), new Permission(28, []), new Permission(29, []), new Permission(30, []), new Permission(31, []), new Permission(32, []), new Permission(33, []), new Permission(34, []), new Permission(35, []), new Permission(36, []), new Permission(37, []), new Permission(38, []), new Permission(39, []), new Permission(40, []), new Permission(41, []), new Permission(42, []), new Permission(43, []), new Permission(44, []), new Permission(45, []), new Permission(46, []), new Permission(47, []), new Permission(48, []), new Permission(49, []), new Permission(50, []), new Permission(51, []), new Permission(52, []), new Permission(53, []), new Permission(54, []), new Permission(55, []), new Permission(56, []), new Permission(57, []), new Permission(58, []), new Permission(59, []), new Permission(60, []), new Permission(61, []), new Permission(62, []), new Permission(63, []), new Permission(64, []), new Permission(65, []), new Permission(66, []), new Permission(67, []), new Permission(68, []), new Permission(69, []), new Permission(70, []), new Permission(71, []), new Permission(72, []), new Permission(73, []), new Permission(74, []), new Permission(75, []), new Permission(76, []), new Permission(77, []), new Permission(78, []), new Permission(79, []), new Permission(80, []), new Permission(81, []), new Permission(82, []), new Permission(83, []), new Permission(84, []), new Permission(85, []), new Permission(86, []), new Permission(87, []), new Permission(88, []), new Permission(89, []), new Permission(90, []), new Permission(91, []), new Permission(92, []), new Permission(93, []), new Permission(94, []), new Permission(95, []), new Permission(96, []), new Permission(97, []), new Permission(98, []), new Permission(99, []), new Permission(100, []), new Permission(101, []), new Permission(102, []), new Permission(103, []), new Permission(104, []), new Permission(105, []), new Permission(106, []), new Permission(107, []), new Permission(108, []), new Permission(109, []), new Permission(110, []), new Permission(111, []), new Permission(112, []), new Permission(113, []), new Permission(114, []), new Permission(115, []), new Permission(116, []), new Permission(117, []), new Permission(118, []), new Permission(119, []), new Permission(120, []), new Permission(121, [])]);

export function PermissionModule_tryParse(key) {
    return tryFind((permission) => (Permission__get_Key(permission) === key), PermissionModule_all);
}

export function PermissionModule_byGroup(group) {
    return filter((permission) => equals(Permission__get_Group(permission), group), PermissionModule_all);
}

export function PermissionModule_column(permission) {
    switch (permission.tag) {
        case 1:
        case 11:
        case 19:
        case 22:
        case 26:
        case 34:
        case 37:
        case 42:
        case 48:
        case 53:
        case 59:
        case 63:
        case 66:
        case 70:
        case 74:
        case 79:
        case 83:
        case 89:
        case 94:
        case 99:
        case 107:
            return new PermissionColumn(1, []);
        case 2:
        case 12:
        case 20:
        case 27:
        case 31:
        case 35:
        case 39:
        case 43:
        case 49:
        case 54:
        case 60:
        case 67:
        case 71:
        case 75:
        case 80:
        case 84:
        case 90:
        case 95:
        case 100:
        case 108:
            return new PermissionColumn(2, []);
        case 3:
        case 13:
        case 21:
        case 23:
        case 28:
        case 36:
        case 40:
        case 44:
        case 50:
        case 55:
        case 61:
        case 64:
        case 68:
        case 72:
        case 76:
        case 81:
        case 85:
        case 91:
        case 96:
        case 101:
        case 109:
            return new PermissionColumn(3, []);
        case 103:
        case 111:
            return new PermissionColumn(4, []);
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 14:
        case 15:
        case 16:
        case 17:
        case 45:
        case 46:
        case 56:
        case 57:
        case 77:
        case 86:
        case 87:
        case 92:
        case 118:
        case 104:
        case 105:
        case 114:
        case 115:
        case 116:
        case 117:
        case 120:
        case 24:
        case 121:
            return new PermissionColumn(5, []);
        default:
            return new PermissionColumn(0, []);
    }
}

export const PermissionModule_groups = PermissionGroupModule_ordered;

export function PermissionModule_ownScopeMeaning(permission) {
    switch (permission.tag) {
        case 0:
        case 18:
        case 25:
        case 113:
        case 119:
            return new OwnScopeMeaning(0, []);
        case 10:
        case 12:
        case 13:
        case 33:
        case 34:
        case 35:
        case 36:
        case 38:
            return new OwnScopeMeaning(1, []);
        case 65:
            return new OwnScopeMeaning(2, []);
        case 82:
            return new OwnScopeMeaning(3, []);
        case 86:
            return new OwnScopeMeaning(4, []);
        case 97:
            return new OwnScopeMeaning(5, []);
        case 110:
            return new OwnScopeMeaning(6, []);
        default:
            return undefined;
    }
}

export function PermissionModule_requires(permission) {
    switch (permission.tag) {
        case 15:
        case 14:
            return singleton(new Permission(11, []));
        case 24:
            return singleton(new Permission(22, []));
        case 29:
            return singleton(new Permission(25, []));
        case 51:
            return singleton(new Permission(47, []));
        case 120:
            return singleton(new Permission(2, []));
        default:
            return empty();
    }
}

export class PermissionGrant extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Graded", "SelectedStorages", "Booking", "WithReceiverTypes"];
    }
}

export function PermissionGrant_$reflection() {
    return union_type("Shared.Roles.PermissionGrant", [], PermissionGrant, () => [[["Item", PermissionScope_$reflection()]], [["Item", list_type(StorageId_$reflection())]], [["Item", BookingScope_$reflection()]], [["Item1", ReceiverScope_$reflection()], ["Item2", list_type(ReceiverTypeName_$reflection())]]]);
}

export function PermissionGrantModule_isGranted(grant) {
    switch (grant.tag) {
        case 1:
            return !isEmpty(grant.fields[0]);
        case 2:
            return !equals(grant.fields[0], new BookingScope(0, []));
        case 3:
            switch (grant.fields[0].tag) {
                case 1:
                    return !isEmpty(grant.fields[1]);
                case 2:
                    return true;
                default:
                    return false;
            }
        default:
            return !equals(grant.fields[0], new PermissionScope(0, []));
    }
}

export function PermissionGrantModule_scope(grant) {
    let matchResult, scope;
    switch (grant.tag) {
        case 1: {
            matchResult = 1;
            break;
        }
        case 3: {
            switch (grant.fields[0].tag) {
                case 1:
                case 2: {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 2;
            }
            break;
        }
        case 2: {
            switch (grant.fields[0].tag) {
                case 1: {
                    matchResult = 5;
                    break;
                }
                case 2: {
                    matchResult = 6;
                    break;
                }
                default:
                    matchResult = 4;
            }
            break;
        }
        default: {
            matchResult = 0;
            scope = grant.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return scope;
        case 1:
            return new PermissionScope(2, []);
        case 2:
            return new PermissionScope(0, []);
        case 3:
            return new PermissionScope(4, []);
        case 4:
            return new PermissionScope(0, []);
        case 5:
            return new PermissionScope(3, []);
        default:
            return new PermissionScope(4, []);
    }
}

export function PermissionGrantModule_isValidFor(ladder, grant) {
    let matchResult, scope, scopes, scopes_1, scope_1;
    switch (ladder.tag) {
        case 2: {
            if (grant.tag === 0) {
                matchResult = 2;
                scope_1 = grant.fields[0];
            }
            else {
                matchResult = 5;
            }
            break;
        }
        case 1: {
            if (grant.tag === 2) {
                matchResult = 3;
            }
            else {
                matchResult = 5;
            }
            break;
        }
        case 3: {
            if (grant.tag === 3) {
                matchResult = 4;
            }
            else {
                matchResult = 5;
            }
            break;
        }
        default:
            switch (grant.tag) {
                case 0: {
                    matchResult = 0;
                    scope = grant.fields[0];
                    scopes = ladder.fields[0];
                    break;
                }
                case 1: {
                    matchResult = 1;
                    scopes_1 = ladder.fields[0];
                    break;
                }
                default:
                    matchResult = 5;
            }
    }
    switch (matchResult) {
        case 0:
            if (!equals(scope, new PermissionScope(2, []))) {
                if (equals(scope, new PermissionScope(0, []))) {
                    return true;
                }
                else {
                    return contains(scope, scopes, {
                        Equals: equals,
                        GetHashCode: (x) => (safeHash(x) | 0),
                    });
                }
            }
            else {
                return false;
            }
        case 1:
            return contains(new PermissionScope(2, []), scopes_1, {
                Equals: equals,
                GetHashCode: (x_1) => (safeHash(x_1) | 0),
            });
        case 2:
            if (equals(scope_1, new PermissionScope(0, []))) {
                return true;
            }
            else {
                return equals(scope_1, new PermissionScope(4, []));
            }
        case 3:
            return true;
        case 4:
            return true;
        default:
            return false;
    }
}

export function PermissionGrantModule_withScope(scope, grant) {
    let matchResult, scope_1;
    if (scope.tag === 2) {
        switch (grant.tag) {
            case 0:
            case 2:
            case 3: {
                matchResult = 1;
                break;
            }
            default:
                matchResult = 0;
        }
    }
    else {
        switch (grant.tag) {
            case 1: {
                matchResult = 2;
                scope_1 = scope;
                break;
            }
            case 2: {
                matchResult = 2;
                scope_1 = scope;
                break;
            }
            case 3: {
                matchResult = 2;
                scope_1 = scope;
                break;
            }
            default: {
                matchResult = 2;
                scope_1 = scope;
            }
        }
    }
    switch (matchResult) {
        case 0:
            return new PermissionGrant(1, [grant.fields[0]]);
        case 1:
            return new PermissionGrant(1, [empty()]);
        default:
            return new PermissionGrant(0, [scope_1]);
    }
}

export function PermissionGrantModule_withReceiverScope(scope, grant) {
    if (scope.tag === 1) {
        if (grant.tag === 3) {
            return new PermissionGrant(3, [scope, grant.fields[1]]);
        }
        else {
            return new PermissionGrant(3, [scope, empty()]);
        }
    }
    else {
        return new PermissionGrant(3, [scope, empty()]);
    }
}

export function PermissionGrantModule_denied(ladder) {
    switch (ladder.tag) {
        case 1:
            return new PermissionGrant(2, [new BookingScope(0, [])]);
        case 3:
            return new PermissionGrant(3, [new ReceiverScope(0, []), empty()]);
        default:
            return new PermissionGrant(0, [new PermissionScope(0, [])]);
    }
}

export class SystemRole extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Administrator", "ToolManager", "User", "ApiReader"];
    }
}

export function SystemRole_$reflection() {
    return union_type("Shared.Roles.SystemRole", [], SystemRole, () => [[], [], [], []]);
}

export function SystemRole__get_Key(this$) {
    switch (this$.tag) {
        case 1:
            return "toolmanager";
        case 2:
            return "user";
        case 3:
            return "api_reader";
        default:
            return "administrator";
    }
}

export function SystemRole__ToI18nString(this$) {
    switch (this$.tag) {
        case 1:
            return "role.tool_manager";
        case 2:
            return "role.user";
        case 3:
            return "role.api_reader";
        default:
            return "role.administrator";
    }
}

export const SystemRoleModule_all = ofArray([new SystemRole(0, []), new SystemRole(1, []), new SystemRole(2, []), new SystemRole(3, [])]);

export const SystemRoleModule_assignable = ofArray([new SystemRole(0, []), new SystemRole(1, []), new SystemRole(2, [])]);

export function SystemRoleModule_tryParse(key) {
    return tryFind((role) => (SystemRole__get_Key(role) === key), SystemRoleModule_all);
}

export function SystemRoleModule_legacyRole(systemRole) {
    switch (systemRole.tag) {
        case 1:
            return "toolManager";
        case 2:
            return "user";
        case 3:
            return "administrator";
        default:
            return "administrator";
    }
}

export function ReceiverTypeKey_ofType(receiverType) {
    switch (receiverType.tag) {
        case 1:
            return "employee";
        case 2:
            return "external_person";
        case 3:
            return "subcontractor";
        case 4:
            return "room";
        case 5:
            return "project";
        case 6:
            return "construction_site";
        case 7:
            return "student";
        case 8:
            return "school_class";
        case 9:
            return "vehicle";
        case 10:
            return "api_receiver";
        default:
            return "user";
    }
}

export function ReceiverTypeKey_tryParse(key) {
    return tryFind((receiverType) => (ReceiverTypeKey_ofType(receiverType) === key), ReceiverTypeNameModule_all);
}

export class RoleDefinition extends Record {
    constructor(Id, Name, SystemKey, SourceSystemKey, Permissions) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.SystemKey = SystemKey;
        this.SourceSystemKey = SourceSystemKey;
        this.Permissions = Permissions;
    }
}

export function RoleDefinition_$reflection() {
    return record_type("Shared.Roles.RoleDefinition", [], RoleDefinition, () => [["Id", RoleId_$reflection()], ["Name", string_type], ["SystemKey", option_type(SystemRole_$reflection())], ["SourceSystemKey", option_type(SystemRole_$reflection())], ["Permissions", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Permission_$reflection(), PermissionGrant_$reflection()])]]);
}

export function RoleDefinitionModule_grant(permission, definition) {
    return defaultArg(tryFind_1(permission, definition.Permissions), PermissionGrantModule_denied(Permission__get_Ladder(permission)));
}

export function RoleDefinitionModule_legacyRole(definition) {
    return defaultArg(map(SystemRoleModule_legacyRole, orElse(definition.SystemKey, definition.SourceSystemKey)), "user");
}

export function RoleDefinitionModule_isAssignable(definition) {
    return !equals(definition.SystemKey, new SystemRole(3, []));
}

export class CreateRoleDto extends Record {
    constructor(Name, SourceSystemRole, Permissions) {
        super();
        this.Name = Name;
        this.SourceSystemRole = SourceSystemRole;
        this.Permissions = Permissions;
    }
}

export function CreateRoleDto_$reflection() {
    return record_type("Shared.Roles.CreateRoleDto", [], CreateRoleDto, () => [["Name", string_type], ["SourceSystemRole", option_type(SystemRole_$reflection())], ["Permissions", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Permission_$reflection(), PermissionGrant_$reflection()])]]);
}

export class UpdateRoleDto extends Record {
    constructor(Name, Permissions) {
        super();
        this.Name = Name;
        this.Permissions = Permissions;
    }
}

export function UpdateRoleDto_$reflection() {
    return record_type("Shared.Roles.UpdateRoleDto", [], UpdateRoleDto, () => [["Name", string_type], ["Permissions", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Permission_$reflection(), PermissionGrant_$reflection()])]]);
}

export class UserRoleAssignmentDto extends Record {
    constructor(UserId, RoleId) {
        super();
        this.UserId = UserId;
        this.RoleId = RoleId;
    }
}

export function UserRoleAssignmentDto_$reflection() {
    return record_type("Shared.Roles.UserRoleAssignmentDto", [], UserRoleAssignmentDto, () => [["UserId", string_type], ["RoleId", RoleId_$reflection()]]);
}

export class RolePermissionsDto extends Record {
    constructor(RoleId, RoleName, SystemRole, Permissions) {
        super();
        this.RoleId = RoleId;
        this.RoleName = RoleName;
        this.SystemRole = SystemRole;
        this.Permissions = Permissions;
    }
}

export function RolePermissionsDto_$reflection() {
    return record_type("Shared.Roles.RolePermissionsDto", [], RolePermissionsDto, () => [["RoleId", RoleId_$reflection()], ["RoleName", string_type], ["SystemRole", option_type(SystemRole_$reflection())], ["Permissions", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [Permission_$reflection(), PermissionGrant_$reflection()])]]);
}

export class SystemRoleSettingsDto extends Record {
    constructor(ToolManagerReceiverWriteTypes, ToolManagerReceiverArchiveTypes, ToolManagerCanDeleteInventory, ToolManagerCanSeeCommercialData, UserCanSeeAllInventory, UserCanSeeCommercialData, UserCanWriteNotices, UserCanReserveForSelf, UserReservationReceiverTypes, UserVisibleReceiverTypes, AllRolesReceiveNotificationEmails, UserCanUseGlobalAppSearch, AssignToUserViaSelection) {
        super();
        this.ToolManagerReceiverWriteTypes = ToolManagerReceiverWriteTypes;
        this.ToolManagerReceiverArchiveTypes = ToolManagerReceiverArchiveTypes;
        this.ToolManagerCanDeleteInventory = ToolManagerCanDeleteInventory;
        this.ToolManagerCanSeeCommercialData = ToolManagerCanSeeCommercialData;
        this.UserCanSeeAllInventory = UserCanSeeAllInventory;
        this.UserCanSeeCommercialData = UserCanSeeCommercialData;
        this.UserCanWriteNotices = UserCanWriteNotices;
        this.UserCanReserveForSelf = UserCanReserveForSelf;
        this.UserReservationReceiverTypes = UserReservationReceiverTypes;
        this.UserVisibleReceiverTypes = UserVisibleReceiverTypes;
        this.AllRolesReceiveNotificationEmails = AllRolesReceiveNotificationEmails;
        this.UserCanUseGlobalAppSearch = UserCanUseGlobalAppSearch;
        this.AssignToUserViaSelection = AssignToUserViaSelection;
    }
}

export function SystemRoleSettingsDto_$reflection() {
    return record_type("Shared.Roles.SystemRoleSettingsDto", [], SystemRoleSettingsDto, () => [["ToolManagerReceiverWriteTypes", list_type(ReceiverTypeName_$reflection())], ["ToolManagerReceiverArchiveTypes", list_type(ReceiverTypeName_$reflection())], ["ToolManagerCanDeleteInventory", bool_type], ["ToolManagerCanSeeCommercialData", bool_type], ["UserCanSeeAllInventory", bool_type], ["UserCanSeeCommercialData", bool_type], ["UserCanWriteNotices", bool_type], ["UserCanReserveForSelf", bool_type], ["UserReservationReceiverTypes", list_type(ReceiverTypeName_$reflection())], ["UserVisibleReceiverTypes", list_type(ReceiverTypeName_$reflection())], ["AllRolesReceiveNotificationEmails", bool_type], ["UserCanUseGlobalAppSearch", bool_type], ["AssignToUserViaSelection", bool_type]]);
}

export class StorageAccess extends Record {
    constructor(StorageId, AssignedUserIds) {
        super();
        this.StorageId = StorageId;
        this.AssignedUserIds = AssignedUserIds;
    }
}

export function StorageAccess_$reflection() {
    return record_type("Shared.Roles.StorageAccess", [], StorageAccess, () => [["StorageId", string_type], ["AssignedUserIds", list_type(string_type)]]);
}

function Permissions_scopeRank(scope) {
    switch (scope.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        default:
            return 0;
    }
}

function Permissions_bookingRank(scope) {
    switch (scope.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        default:
            return 0;
    }
}

export function Permissions_grant(context, permission) {
    return defaultArg(tryFind_1(permission, context.Permissions), PermissionGrantModule_denied(Permission__get_Ladder(permission)));
}

export function Permissions_has(context, permission) {
    return PermissionGrantModule_isGranted(Permissions_grant(context, permission));
}

export function Permissions_scope(context, permission) {
    return PermissionGrantModule_scope(Permissions_grant(context, permission));
}

export function Permissions_scopeAtLeast(context, permission, minimum) {
    return Permissions_scopeRank(Permissions_scope(context, permission)) >= Permissions_scopeRank(minimum);
}

export function Permissions_bookingScope(context, permission) {
    const matchValue = Permissions_grant(context, permission);
    switch (matchValue.tag) {
        case 0:
        case 1:
        case 3:
            return new BookingScope(0, []);
        default:
            return matchValue.fields[0];
    }
}

export function Permissions_bookingScopeAtLeast(context, permission, minimum) {
    return Permissions_bookingRank(Permissions_bookingScope(context, permission)) >= Permissions_bookingRank(minimum);
}

export function Permissions_allowsReceiverType(context, permission, receiverType) {
    const matchValue = Permissions_grant(context, permission);
    let matchResult, receiverTypes;
    switch (matchValue.tag) {
        case 0:
        case 1:
        case 2: {
            matchResult = 3;
            break;
        }
        default:
            switch (matchValue.fields[0].tag) {
                case 1: {
                    matchResult = 1;
                    receiverTypes = matchValue.fields[1];
                    break;
                }
                case 0: {
                    matchResult = 2;
                    break;
                }
                default:
                    matchResult = 0;
            }
    }
    switch (matchResult) {
        case 0:
            return true;
        case 1:
            return contains(receiverType, receiverTypes, {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            });
        case 2:
            return false;
        default:
            return false;
    }
}

export function Permissions_allowsStorage(context, permission, storageId) {
    const matchValue = Permissions_grant(context, permission);
    if (matchValue.tag === 1) {
        return contains(storageId, matchValue.fields[0], {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        });
    }
    else {
        return PermissionGrantModule_isGranted(matchValue);
    }
}

export function Permissions_hasAny(context, permissions) {
    return exists((permission) => Permissions_has(context, permission), permissions);
}

function Permissions_isSelectedStorage(storageIds, storageId) {
    return exists((_arg) => (_arg.fields[0] === storageId), storageIds);
}

function Permissions_grantAllowsStorage(grant, userId, storageId, assignedUserIds) {
    let matchResult, storageIds;
    switch (grant.tag) {
        case 1: {
            matchResult = 2;
            storageIds = grant.fields[0];
            break;
        }
        case 2: {
            switch (grant.fields[0].tag) {
                case 1: {
                    matchResult = 5;
                    break;
                }
                case 0: {
                    matchResult = 6;
                    break;
                }
                default:
                    matchResult = 4;
            }
            break;
        }
        case 3: {
            matchResult = 7;
            break;
        }
        default:
            switch (grant.fields[0].tag) {
                case 3: {
                    matchResult = 1;
                    break;
                }
                case 1:
                case 2:
                case 0: {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 0;
            }
    }
    switch (matchResult) {
        case 0:
            return true;
        case 1:
            return contains(userId, assignedUserIds, {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            });
        case 2:
            return Permissions_isSelectedStorage(storageIds, storageId);
        case 3:
            return false;
        case 4:
            return true;
        case 5:
            return contains(userId, assignedUserIds, {
                Equals: (x_1, y_1) => (x_1 === y_1),
                GetHashCode: (x_1) => (stringHash(x_1) | 0),
            });
        case 6:
            return false;
        default:
            return PermissionGrantModule_isGranted(grant);
    }
}

export function Permissions_allowsInStorage(context, permission, userId, storageId, assignedUserIds) {
    return Permissions_grantAllowsStorage(Permissions_grant(context, permission), userId, storageId, assignedUserIds);
}

export function Permissions_allowsObject(context, permission, userId, storage, ownerUserId) {
    const isOwner = equals(ownerUserId, userId);
    const matchValue = Permissions_grant(context, permission);
    let matchResult, grant_1, grant_2;
    switch (matchValue.tag) {
        case 1: {
            matchResult = 2;
            grant_1 = matchValue;
            break;
        }
        case 2: {
            matchResult = 4;
            grant_2 = matchValue;
            break;
        }
        case 3: {
            matchResult = 4;
            grant_2 = matchValue;
            break;
        }
        default:
            switch (matchValue.fields[0].tag) {
                case 1: {
                    matchResult = 1;
                    break;
                }
                case 2:
                case 0: {
                    matchResult = 3;
                    break;
                }
                case 3: {
                    matchResult = 2;
                    grant_1 = matchValue;
                    break;
                }
                default:
                    matchResult = 0;
            }
    }
    switch (matchResult) {
        case 0:
            return true;
        case 1:
            return isOwner;
        case 2:
            if (isOwner) {
                return true;
            }
            else {
                return exists_1((storage_1) => Permissions_grantAllowsStorage(grant_1, userId, storage_1.StorageId, storage_1.AssignedUserIds), toArray(storage));
            }
        case 3:
            return false;
        default:
            return PermissionGrantModule_isGranted(grant_2);
    }
}

export function Permissions_allowsBooking(context, permission, userId, assignedUserIds, hasStorageRuleAccess) {
    const matchValue = Permissions_grant(context, permission);
    let matchResult;
    switch (matchValue.tag) {
        case 0:
        case 1:
        case 3: {
            matchResult = 2;
            break;
        }
        default:
            switch (matchValue.fields[0].tag) {
                case 1: {
                    matchResult = 1;
                    break;
                }
                case 0: {
                    matchResult = 2;
                    break;
                }
                default:
                    matchResult = 0;
            }
    }
    switch (matchResult) {
        case 0:
            return true;
        case 1:
            if (contains(userId, assignedUserIds, {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            })) {
                return true;
            }
            else {
                return hasStorageRuleAccess;
            }
        default:
            return false;
    }
}

